import styled from 'styled-components';

export const DropdownContainer = styled.div`
  width: 900px;
  position: absolute;
`;
